import type { Certification, Density } from "../types/inpact";

interface CertificationChipProps {
  cert: Certification;
  density?: Density;
}

export function CertificationChip({ cert, density = "comfortable" }: CertificationChipProps) {
  const cls = `cert-chip__level cert-chip__level--${cert.level.toLowerCase()}`;
  const ariaLabel = cert.awardedDate
    ? `Certification: ${cert.name}, level ${cert.level}, awarded ${cert.awardedDate}`
    : `Certification: ${cert.name}, level ${cert.level}`;
  return (
    <span className="cert-chip" aria-label={ariaLabel}>
      <span className={cls}>{cert.level}</span>
      <span>{cert.name}</span>
      {density !== "compact" && cert.awardedDate && (
        <span className="cert-chip__date">· {cert.awardedDate}</span>
      )}
    </span>
  );
}
